






























import { Component, Vue, Prop } from "vue-property-decorator";
import { IContract, IContractProduct } from "@/models/contracts";

@Component({
  components: {
    "cprod-provider": () =>
      import("@/components/app/global/contractProducts/cProdProvider.vue"),
    "cprod-prov-provider": () =>
      import("@/components/app/global/contractProducts/cProdProvProvider.vue"),
    "cprod-cancellation-request": () =>
      import(
        "@/components/app/global/contractProducts/cProdCancellationRequest.vue"
      ),
    "cprod-unpaid-invoices-msg": () =>
      import(
        "@/components/app/global/contractProducts/cProdUnpaidInvoicesMsg.vue"
      ),
    "cprod-header": () =>
      import(`@/components/app/global/client/contractProducts/cProdHeader.vue`),
    "cprod-auto-expire-msg": () =>
      import("@/components/app/global/contractProducts/cProdAutoExpireMsg.vue"),
    "delegated-object-message": () =>
      import("@/components/app/global/delegates/delegatedObjectMsg.vue")
  }
})
export default class UpmindClientContractProduct extends Vue {
  // Props

  @Prop({ default: () => [] })
  public routes!: (vm: UpmindClientContractProduct & any) => any[];

  @Prop({ required: true })
  public productId!: IContractProduct["id"];

  @Prop({ required: true })
  public contractId!: IContract["id"];

  // Computed

  public get cProdIds() {
    return {
      contractId: this.contractId,
      productId: this.productId
    };
  }

  public get showCancellationMessages() {
    if (
      ["clientCProdSettings", "admin__upmindClientCProdSettings"].includes(
        this.$route?.name as string
      )
    )
      return false;
    return true;
  }
}
